import React, { useState } from 'react';
import { useFadeIn } from '../hooks/useFadeIn';
import './Contact.css';

const inquiryOptions = [
  'Intelligence & Analytics Solutions',
  'Security Assessment',
  'Data Privacy & Secure Communications',
  'SCRIP Program Application',
  'R&D Partnership',
  'General Inquiry',
];

export default function Contact() {
  const leftRef  = useFadeIn();
  const rightRef = useFadeIn();

  const [form, setForm] = useState({
    fname: '', lname: '', org: '',
    email: '', phone: '', subject: '', message: '',
  });
  const [sent, setSent] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSent(true);
    setTimeout(() => {
      setSent(false);
      setForm({ fname: '', lname: '', org: '', email: '', phone: '', subject: '', message: '' });
    }, 3500);
  };

  return (
    <section id="contact" className="contact-section">
      <div className="contact-bg" />
      <div className="contact-inner">

        {/* LEFT — contact info */}
        <div className="contact-info fade-in" ref={leftRef}>
          <div className="section-label">Get in Touch</div>
          <h2 className="contact-title">We prefer to <em>talk.</em></h2>
          <p className="contact-body">
            Whether you're a corporate client seeking intelligence solutions, a public institution
            requiring security assessments, or a student interested in SCRIP — our door is open.
            Your first point of contact is always a direct, confidential conversation.
          </p>

          <div className="contact-methods">
            <div className="contact-method">
              <div className="method-icon">📞</div>
              <div>
                <div className="method-label">Preferred — Phone</div>
                <a href="tel:+237657108461" className="method-value">+(237) GRANTSMAN</a>
                <div className="method-note">Business hours · Mon–Fri, 8am–6pm</div>
              </div>
            </div>

            <div className="contact-method">
              <div className="method-icon">✉️</div>
              <div>
                <div className="method-label">Preferred — Email</div>
                <a href="mailto:info@grantsmangroup.com" className="method-value">
                  info@grantsmangroup.com
                </a>
                <div className="method-note">Response within one business day</div>
              </div>
            </div>

            <div className="contact-method">
              <div className="method-icon">🔒</div>
              <div>
                <div className="method-label">Privacy Commitment</div>
                <span className="method-value method-value--text">
                  Your information is handled with strict confidentiality. We will not share your
                  data with any third party without your explicit consent. Resume and application
                  data is stored for employment consideration only, for up to one year.
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT — form */}
        <form className="contact-form fade-in delay-2" ref={rightRef} onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="fname">First Name</label>
              <input
                id="fname" name="fname" type="text"
                placeholder="Mbah" required
                value={form.fname} onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="lname">Last Name</label>
              <input
                id="lname" name="lname" type="text"
                placeholder="peter" required
                value={form.lname} onChange={handleChange}
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="org">Organization</label>
            <input
              id="org" name="org" type="text"
              placeholder="Your Company or Institution"
              value={form.org} onChange={handleChange}
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input
                id="email" name="email" type="email"
                placeholder="mbah@company.com" required
                value={form.email} onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="phone">Phone Number</label>
              <input
                id="phone" name="phone" type="tel"
                placeholder="+(237) 000-0000"
                value={form.phone} onChange={handleChange}
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="subject">Nature of Inquiry</label>
            <select
              id="subject" name="subject"
              value={form.subject} onChange={handleChange}
            >
              <option value="">Select an area…</option>
              {inquiryOptions.map((opt) => (
                <option key={opt} value={opt}>{opt}</option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="message">Message</label>
            <textarea
              id="message" name="message" rows={5}
              placeholder="Briefly describe your intelligence or security needs…"
              value={form.message} onChange={handleChange}
            />
          </div>

          <div className="form-footer">
            <p className="form-note">
              All submissions are subject to our due diligence process and privacy policy.
            </p>
            <button
              type="submit"
              className={`btn-primary${sent ? ' btn-sent' : ''}`}
            >
              {sent ? 'Message Sent ✓' : 'Send Inquiry →'}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}
